import React, { createContext } from 'react';

const localStorageKey = 'quoteItems2021006';

const setLocalStorage = (key, value) => {
    try {
        window.localStorage.setItem( key, JSON.stringify(value));
    } catch (e) {
        console.log(e);
    }
}

const getLocalStorage = (key, initialValue) => {
    try {
        const value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : initialValue;
    } catch (e) {
        return initialValue;
    }
}

const initialState = {
    customItem: {},
    matchedProducts: [],
    quoteItems: getLocalStorage(localStorageKey, {
        standard: [],
        custom: []
    }),
    step: 1
}

const reducer = (state, action) => {
    switch(action.type) {
        case 'products/setMatchedProducts':
            return {
                ...state, matchedProducts: [...action.value]
            }
        case 'customItem/addItem':
            return {
                ...state, customItem: action.value
            }
        case 'quoteItems/addItem':
            const quoteItemsAdd = {...state.quoteItems};
            quoteItemsAdd.standard.push(action.value);
            setLocalStorage(localStorageKey, quoteItemsAdd);
            return {
                ...state, quoteItems: quoteItemsAdd
            }
        case 'quoteItems/addCustomItem':
            const customQuoteItemsAdd = {...state.quoteItems};
            customQuoteItemsAdd.custom.push(action.value);
            setLocalStorage(localStorageKey, customQuoteItemsAdd);
            return {
                ...state, quoteItems: customQuoteItemsAdd
            }
        case 'quoteItems/emptyQuote':
            let quoteItemsEmpty = {
                standard: [],
                custom: []
            };
            setLocalStorage(localStorageKey, quoteItemsEmpty);
            return {
                ...state, quoteItems: {...quoteItemsEmpty}
            }
        case 'quoteItems/removeItem':
            let quoteItemsRemove = {...state.quoteItems};
            quoteItemsRemove[action.value.type] = quoteItemsRemove[action.value.type].filter(item => {
                if( action.value.type === 'custom' ) {
                    return item.PR !== action.value.PR
                } else {
                    return item.PR !== parseInt(action.value.PR)
                }
                
            });
            setLocalStorage(localStorageKey, quoteItemsRemove);
            return {
                ...state, quoteItems: {...quoteItemsRemove}
            }
        case 'quoteItems/updateItem':
            const prevQuoteItems = {...state.quoteItems};
            prevQuoteItems[action.value.type] = prevQuoteItems[action.value.type].map((item, index) => {
                if( item.PR === action.value.PR) {
                    const newQty = item.qty + action.value.qty;
                    item.qty = newQty >= 0 ? newQty : 0;
                }
                return item;
            });
            setLocalStorage(localStorageKey, prevQuoteItems);
            return {
                ...state, quoteItems: {...prevQuoteItems}
            }
        case 'steps/setCurrentStep':
            return {
                 ...state, step: state.step + action.value
            }
        case 'steps/setExactStep':
            return {
                 ...state, step: action.value
            }
        default:
            return state;
    }
}

const GlobalContext = createContext();

const GlobalContextProvider = ({ children }) => {

    const [state, dispatch] = React.useReducer(reducer, initialState);

    const value = {
        customItem: state.customItem,
        matchedProducts: state.matchedProducts,
        quoteItems: state.quoteItems,
        step: state.step,
        addCustomItem: value => {
            dispatch({ type: 'customItem/addItem', value })
        },
        addQuoteItem: value => {
            dispatch({ type: 'quoteItems/addItem', value })
        },
        addCustomQuoteItem: value => {
            dispatch({ type: 'quoteItems/addCustomItem', value })
        },
        emptyQuote: value => {
            dispatch({ type: 'quoteItems/emptyQuote', value })
        },
        removeQuoteItem: value => {
            dispatch({ type: 'quoteItems/removeItem', value })
        },
        updateQuoteItem: value => {
            dispatch({ type: 'quoteItems/updateItem', value})
        },
        setMatchedProducts: value => {
            dispatch({ type: 'products/setMatchedProducts', value})
        },
        setStep: value => {
            dispatch({ type: 'steps/setCurrentStep', value})
        },
        setExactStep: value => {
            dispatch({ type: 'steps/setExactStep', value})
        }
    }

    return (
        <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
    )
}

export { GlobalContextProvider as default, GlobalContext }